//Hooks
import { get } from 'svelte/store';
//Formatters
import { format } from 'svelte-i18n';
//Helpers
import { real_id } from './interface_helpers';
//Stores
import { devices_status, devices_settings } from 'src/stores/device-runtime/status';
import { devices } from 'src/stores/lists/devices';
//Types
import type { Device } from '../types/Device';
//
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';

export const hasAvailableExtSensors = (device: Device) => {
	return /^(SHSW-1|SHSW-PM|SHUNI-1)$/.test(device.type);
};

export const getExtSensorsSettings: any = (device: Device, type: 'temperature' | 'humidity') => {
	const sensorSettings = [];
	if (hasAvailableExtSensors(device)) {
		const id = real_id(device.id),
			deviceStatus = devices_status.getByRealId(device.id);
		if (deviceStatus && deviceStatus.ext_sensors) {
			const sensorType = `ext_${type}`,
				extStatus: { tC: number; hum: number }[] = deviceStatus[sensorType] || {},
				extSettings = devices_settings.getByRealId(device.id)?.[sensorType] || {},
				extNames = get(devices)[id]?.external_sensors_names || {},
				unit = type == 'humidity' ? '%' : deviceStatus.ext_sensors?.temperature_unit || 'C';
			for (let key in extStatus) {
				const extid = Number(key),
					sensor = extStatus[key],
					settings =
						device.channels_count > 1
							? extSettings?.[extid]?.[device.channel]
							: extSettings?.[extid];
				if (
					settings &&
					((type == 'temperature' && sensor.tC != null && sensor.tC != 999) ||
						(type == 'humidity' && sensor.hum != null && sensor.hum != 999))
				) {
					const extName = extNames[`${extid}_${type}`];
					sensorSettings.push({
						...settings,
						id,
						type,
						unit,
						extid,
						channel: device.channel,
						value:
							type == 'humidity'
								? sensor.hum.toFixed(1) + ` ${unit}`
								: sensor[`t${unit}`].toFixed(1) + ` °${unit}`,
						name:
							extName && extName.name !== 'unnamed'
								? extName.name
								: get(format)('external_sensor_named', {
										values: { index_or_name: extid },
										default: 'External sensor {index_or_name}',
									}),
					});
				}
			}
		}
	}
	return sensorSettings;
};

export const getSensorAutomationOptions = (): SelectOptionPropsType[] => {
	const $format = get(format);
	return [
		{
			title: $format('option_disabled', { default: 'Disabled' }),
			value: 'disabled',
		},
		{
			title: $format('option_on', { default: 'Relay on' }),
			value: 'relay_on',
		},
		{
			title: $format('option_off', { default: 'Relay off' }),
			value: 'relay_off',
		},
	];
};

export const hasExternalSensors = (device: Device, type: 'temperature' | 'humidity' = 'temperature') => {
	return getExtSensorsSettings(device, type).length > 0;
};

export const getExtSensorsStatus = (device: Device, interface_data = []) => {
	getExtSensorsSettings(device, 'temperature').map((sensor) => {
		interface_data.push({
			name: `temperature:${sensor.extid}`,
			icon: 'fa fa-thermometer-three-quarters',
			value: sensor.value,
			sensor,
		});
	});
	getExtSensorsSettings(device, 'humidity').map((sensor) => {
		interface_data.push({
			name: 'humidity',
			icon: 'fa fa-humidity',
			value: sensor.value,
			sensor,
		});
	});
	return interface_data;
};

export const transform_ext_humidity = (data) => {
	if (typeof data?.ext_humidity === 'object') {
		data.ext_humidity = Object.values(data.ext_humidity);
	}
	return data;
};

export const transform_ext_temperature = (data) => {
	if (typeof data?.ext_temperature === 'object') {
		data.ext_temperature = Object.values(data.ext_temperature);
	}
	return data;
};
